import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import {
  ChartBarHorizontalCustom,
  Legend,
  LoaderWrapper,
  ReportHeading,
  ProgressionWrapper,
  ProgressionFilters,
  ReportOuterWrapper,
  MuiMultiSelect,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { getObjectAsArray, exportExcel_addPercentage, getProgressionArray } from '../../../../util'
import { LEGEND_COLOR_MAP_NEW, GRAPH_COLOR_PALLET_V2, GRAPH_COLOR_PALLET_V2_TEXT, GRAPH_COLOR_PALLET4 } from '../../../../constants'
import BuyerTable from './progressionBuyerTable'
import { ProgressionWrapper as ProgressWrapper } from '../reportCustomTable/style'

import {
  RootWrap,
  TabSection1,
  TabSection2,
  ProgressionFiltersWrapper,
  BrandHealthSection,
  HeadingSection,
  ContentSection,
  ChartRow,
  RowName,
  LegendWrap,
  FilterWrapper,
} from './style'
import GraphGridTab from '../comparisonViewDeepDiveNew/graphGridTab'
import { Table } from '../comparisonViewDeepDiveNew/graphGridTab'
import { IconListBtn } from '../../../../assets/images/icons'
import ProgressionRange from '../comparisonViewDeepDiveNew/progressionRange'

// ✅ New component extracted from LoaderWrapper section
export const SegmentProgressionContent = ({
  props,
  show,
  onBtnClick,
  state,
  stateValue,
  checkBoxData,
  segmentData,
  filterValue,
  segmentValues,
  allValuesShow,
  configTab,
  progressionDataL1Filtered,
  progressionDataFiltered,
  progressionData,
  progressionRangeObject,
  progressionRangeData,
  setProgressionRangeObject,
  filterChangeFunc,
  filterSegmentChangeFunc,
  setEventCount,
}) => {
  return (
    <>
      <ProgressWrapper>
        <FilterWrapper>
          {checkBoxData.length > 0 && (
            <MuiMultiSelect
              name={checkBoxData.length}
              placeholder="Select Segments"
              onChange={(val) => filterChangeFunc(val)}
              onSelectAll={(val) => {
                const newVal = val ? checkBoxData : []
                filterChangeFunc(newVal)
              }}
              data={checkBoxData}
              value={filterValue}
              style={{ width: '100%', maxWidth: '200px' }}
              search={true}
            />
          )}

          {segmentData.length > 0 && (
            <MuiMultiSelect
              name={segmentData.length}
              placeholder="Select Period"
              onChange={(val) => filterSegmentChangeFunc(val)}
              onSelectAll={(val) => {
                const newVal = val ? segmentData : []
                filterSegmentChangeFunc(newVal)
              }}
              data={segmentData}
              value={segmentValues}
              style={{ width: '100%', maxWidth: '200px' }}
              search={true}
            />
          )}
        </FilterWrapper>

        <FilterWrapper width={'fit-content'}>
          <GraphGridTab
            onClick={onBtnClick}
            show={show}
            GraphIcon={Table}
            TableIcon={IconListBtn}
            disableActiveBg={true}
          />

          {!!state.length && progressionRangeData.length !== 0 && (
            <ProgressionRange
              data={progressionRangeData}
              progressionRangeObject={progressionRangeObject}
              setProgressionRangeObject={setProgressionRangeObject}
            />
          )}
        </FilterWrapper>
      </ProgressWrapper>

      <ProgressionWrapper
        configTab={configTab}
        onChange={() => setEventCount((p) => p + 1)}
        defaultTab={
          props?.isProgressionActive &&
          props.InsightsElementType === 'SegmentOfSegmentOverviewAndProgression'
            ? 1
            : 0
        }
      >
        <TabSection1 hasTabs={props.InsightsElementType === 'SegmentOfSegmentOverviewAndProgression'}>
          {!!stateValue.length && (
            <BuyerTable
              view={show}
              isExtraColor={props.isExtraColor}
              data={stateValue}
              colorPallet={[...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]}
              showLegendToolTip={true}
              allValuesShow={allValuesShow}
              insightsElementType={props.InsightsElementType}
            />
          )}
        </TabSection1>

        <TabSection2>
          <ProgressionFiltersWrapper>
            {state?.length > 0 && (
              <ProgressionFilters
                data={progressionDataL1Filtered}
                onChange={filterChangeFunc}
              />
            )}
          </ProgressionFiltersWrapper>

          {progressionData?.sentimentSplit.map((d, i) => {
            if (!progressionDataFiltered?.drivers?.includes(d[0].name)) {
              return false
            }
            return (
              <BrandHealthSections
                key={i}
                heading={d[0].name}
                className="segmentOfSegmentOverviewRowProgression"
              >
                {d.map((g, i) => {
                  if (!progressionDataFiltered?.periods?.includes(g.title)) {
                    return false
                  }
                  const keys = Object.keys(g).filter((f) => !['title', 'name'].includes(f))
                  const dataObj = {}
                  for (let i = 0; i < keys.length; i++) {
                    dataObj[keys[i]] = g[keys[i]]
                  }
                  return (
                    <Box key={'graph1_' + i}>
                      <ChartRow className="graphRow">
                        <RowName>{g?.title}</RowName>
                        <ChartBarHorizontalCustom
                          maxWidth="90%"
                          valueInPercent
                          data={[dataObj]}
                          maxPercentRatio={1}
                          colorIndex={LEGEND_COLOR_MAP_NEW}
                        />
                      </ChartRow>
                    </Box>
                  )
                })}
              </BrandHealthSections>
            )
          })}

          {progressionData?.legendData && (
            <LegendWrap className="legend">
              <Legend legends={progressionData?.legendData} colorPallet={GRAPH_COLOR_PALLET4} />
            </LegendWrap>
          )}
        </TabSection2>
      </ProgressionWrapper>
    </>
  )
}

const SegmentProgression = (props) => {
  const [show, setShow] = useState('graph')
  const [state, setState] = useState([])
  const [loading, setLoading] = useState(false)
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [checkBoxData, setCheckboxData] = useState([])
  const [segmentData, setSegmentData] = useState([])
  const [segmentValues, setSegmentValues] = useState([])
  const [filterValue, setFilterValues] = useState([])
  const [pptData, setPptData] = useState({})
  const [allValuesShow, setAllValuesShow] = useState(true)
  const [progressionRangeObject, setProgressionRangeObject] = useState({})
  const [progressionRangeData, setProgressionRangeData] = useState([])
  const [stateValue, setStateValue] = useState([])
  const [progressionDataL1Filtered, setProgressionDataL1Filtered] = useState({ drivers: [], periods: [] })
  const [progressionDataFiltered, setProgressionDataFiltered] = useState({ drivers: [], periods: [] })
  const [configTab, setConfigTab] = useState([])
  const [progressionData, setProgressionData] = useState()
  const [eventCount, setEventCount] = useState(1)
  const [pageFlag, setPageFlag] = useState(false)

  let scoreImageryTypeArray = {}
  let scoreImageryTypeArrayL2 = {}
  const filterDataObj = { drivers: [], periods: [] }

  const hasTabs = props.InsightsElementType === 'SegmentOfSegmentOverviewAndProgression'
  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: hasTabs
        ? ReportsService.getSegmentOfSegmentProgressionElement
        : ReportsService.getSegmentOfSegmentOverviewElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }

  const { data, isLoading, isSuccess, isError, error } = useReactQuery(useReactQueryObject)

  const generateBuyerMaturityData = async (resp, hasTabs) => {
    scoreImageryTypeArray = {}
    scoreImageryTypeArrayL2 = {}

    const rowArrayDataFunc = (data, dataObj) => {
      filterDataObj.periods.push(dataObj?.title || '')
      filterDataObj.drivers.push(data.map((d) => d.PrimarySegmentName))
      return data
    }

    const configTabObject = hasTabs
      ? resp.map((d, i) => ({
          periodInsightsElementId: d.PeriodInsightsElementId,
          id: i,
          label: i === 0 ? d.PeriodName : 'Progression',
          tutorial: i === 0 ? 'CurrentPeriod' : 'Progression',
          title: d.PeriodName,
          periodOrder: d.PeriodOrder,
          data: getObjectAsArray(
            d?.SegmentOfSegmentOverviewElements?.SegmentOfSegmentOverviewElement || []
          ),
        }))
      : []

    const rowArrayData = hasTabs
      ? configTabObject.map((d) => {
          d.data = rowArrayDataFunc(d.data, d)
          return d
        })
      : [rowArrayDataFunc(resp, null)]

    const removeUsingSet = (arr) => Array.from(new Set(arr))
    const progressionDataL1FilteredData = {
      drivers: removeUsingSet(filterDataObj.drivers.flat(1)),
      periods: removeUsingSet(filterDataObj.periods),
    }
    setProgressionDataL1Filtered(progressionDataL1FilteredData)

    const loadTab1Func = (paramData) => {
      const data = paramData.map((elem) => ({
        ...elem,
        show: true,
        PeriodName: elem?.PrimarySegmentName,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map(
            (obj, i) => ({ ...obj, show: true, segmentIndex: i })
          ),
        },
      }))

      setPptData({ content: data })
      setState(data)
      setStateValue(data)
      const rangeData = getProgressionArray(data, 'popup')
      setProgressionRangeData(rangeData)

      for (let i of getObjectAsArray(paramData[0]?.SecondarySegmentSet?.SecondarySegment)) {
        setCheckboxData((prev) => [...prev, i?.SegmentName])
      }

      for (let i of paramData) {
        setSegmentData((prev) => [...prev, i?.PrimarySegmentName])
      }

      const reportExcelDataObj = []
      for (let i = 0; i < paramData.length; i++) {
        const segmentSet = getObjectAsArray(
          paramData[i]?.SecondarySegmentSet?.SecondarySegment || []
        )
        for (let j = 0; j < segmentSet.length; j++) {
          reportExcelDataObj.push([
            { value: paramData[i].PrimarySegmentName },
            { value: segmentSet[j].SegmentName },
            exportExcel_addPercentage(segmentSet[j].SegmentValue),
          ])
        }
      }
      setReportExcelData(reportExcelDataObj)
    }

    if (hasTabs) {
      setConfigTab(configTabObject)
      const finalData = { sentimentSplit: [], sentimentSplitTemp: [], legendData: [] }

      for (let i = 0; i < rowArrayData.length; i++) {
        const d0 = rowArrayData[i].data
        for (let j = 0; j < d0.length; j++) {
          const d1 = d0[j]
          const obj = { title: rowArrayData[i].title, name: d1.PrimarySegmentName }
          const arr = getObjectAsArray(d1.SecondarySegmentSet.SecondarySegment)
          for (let k = 0; k < arr.length; k++) {
            if (!finalData.legendData.includes(arr[k].SegmentName)) {
              finalData.legendData.push(arr[k].SegmentName)
            }
            obj[arr[k].SegmentName.trim().replaceAll(' ', '')] = arr[k].SegmentValue
          }
          finalData.sentimentSplitTemp.push(obj)
        }
      }

      finalData.legendData = finalData.legendData.map((d, i) => ({ label: d, value: i }))
      for (let m = 0; m < progressionDataL1FilteredData.drivers.length; m++) {
        const m1 = progressionDataL1FilteredData.drivers[m]
        const m2 = finalData.sentimentSplitTemp.filter((f) => f.name === m1)
        finalData.sentimentSplit.push(m2)
      }

      loadTab1Func(rowArrayData[0].data)
      setProgressionData(finalData)
    } else {
      loadTab1Func(resp)
    }

    setLoading(false)
    setEventCount((p) => p + 1)
    setTimeout(() => {
      updateSubLhsApiLoaded(props)
    }, 2000)
  }

  const filterChangeFunc = (selectedValue) => {
    setAllValuesShow(selectedValue.length > 0)
    const selectedValues = selectedValue.filter((val) => val !== 'All')
    const data = state?.map((elem) => ({
      ...elem,
      SecondarySegmentSet: {
        ...elem.SecondarySegmentSet,
        SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj) => ({
          ...obj,
          show: selectedValues.includes(obj.SegmentName),
        })),
      },
    }))
    setState(data)
    setStateValue(data)
    setFilterValues(selectedValue)
  }

  const filterSegmentChangeFunc = (selectedValue) => {
    setAllValuesShow(selectedValue.length > 0)
    const selectedValues = selectedValue.filter((val) => val !== 'All')
    const data = state?.map((elem) => ({ ...elem, show: selectedValues.includes(elem.PrimarySegmentName) }))
    setState(data)
    setStateValue(data)
    setSegmentValues(selectedValue)
  }

  useEffect(() => {
    if (isSuccess && data?.length) generateBuyerMaturityData(data, hasTabs)
  }, [isSuccess, data])

  useEffect(() => {
    filterChangeFunc(checkBoxData)
  }, [checkBoxData])

  useEffect(() => {
    filterSegmentChangeFunc(segmentData)
  }, [segmentData])

  useEffect(() => {
    if (progressionRangeObject.barsInGraph) {
      const data = state?.slice(0, progressionRangeObject.barsInGraph)
      setStateValue(data)
      setCheckboxData([])
      for (let i of getObjectAsArray(data[0]?.SecondarySegmentSet?.SecondarySegment)) {
        setCheckboxData((prev) => [...prev, i?.SegmentName])
      }
      setSegmentData([])
      for (let i of data) {
        setSegmentData((prev) => [...prev, i?.PrimarySegmentName])
      }
    }
  }, [progressionRangeObject, data])

  return (
    <>
      {reportExcelData && (
        <ReportHeading
          resetInsightHeight={eventCount}
          downloadId={props.type}
          pptData={pptData}
          {...props}
          downloadIdData={reportExcelData}
        />
      )}
      <ReportOuterWrapper>
        <RootWrap id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <SegmentProgressionContent
              props={props}
              show={show}
              onBtnClick={setShow}
              state={state}
              stateValue={stateValue}
              checkBoxData={checkBoxData}
              segmentData={segmentData}
              filterValue={filterValue}

              segmentValues={segmentValues}
              allValuesShow={allValuesShow}
              configTab={configTab}
              progressionDataL1Filtered={progressionDataL1Filtered}
              progressionDataFiltered={progressionDataFiltered}
              progressionData={progressionData}
              progressionRangeObject={progressionRangeObject}
              progressionRangeData={progressionRangeData}
              setProgressionRangeObject={setProgressionRangeObject}
              filterChangeFunc={filterChangeFunc}
              filterSegmentChangeFunc={filterSegmentChangeFunc}
              setEventCount={setEventCount}
            />
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default SegmentProgression

const BrandHealthSections = ({ heading, className, children }) => (
  <BrandHealthSection className={className}>
    <HeadingSection className="heading">{heading}</HeadingSection>
    <ContentSection>{children}</ContentSection>
  </BrandHealthSection>
)
